import { getFirebaseApp } from 'root/services/auth';

import { Logger as log } from '../logger';

export async function uploadToFirebase(file: File, path: string, opts?: IOptionResizeImage, name: string = '') {
  if (opts) {
    file = await resizeImage(file, opts);
  }
  const tokens = file.name.split('.');
  const fileName = name ? `${name}.${tokens[tokens.length - 1]}` : ((new Date()).getTime() + file.name);
  const storageRef = getFirebaseApp().storage().ref(),
    currentRef = storageRef.child(path + fileName);
  await currentRef.put(file);

  return currentRef.getDownloadURL();
}

export interface IOptionResizeImage {
  maxWidth: number;
  maxHeight: number;
}

export async function resizeImage(file: File, opts: IOptionResizeImage | IOptionResizeImage[]): Promise<any> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    let oneFile = false;

    if (!Array.isArray(opts)) {
      opts = [opts];
      oneFile = true;
    }
    const confs: IOptionResizeImage[] = opts;

    reader.readAsDataURL(file);
    reader.onload = (e: any) => {

      const fileHandle = e.target.result;
      // Handle get information image
      const imgBase = document.createElement('img');
      imgBase.src = fileHandle;
      const canvasBase = document.createElement('canvas');
      const initialCtxBase = canvasBase.getContext('2d');
      initialCtxBase.drawImage(imgBase, 0, 0);
      const widthBase = imgBase.width;
      const heightBase = imgBase.height;

      if (widthBase === 0 && heightBase === 0) {
        return resizeImage(file, opts).then((result) => {
          if (oneFile) {
            return resolve(result[0]);
          }

          return resolve(result);
        });
      }

      const resize = (MAX_WIDTH, MAX_HEIGHT) => {

        return new Promise((resolveT) => {
          const img = document.createElement('img');
          img.src = fileHandle;
          const canvas = document.createElement('canvas');
          const initialCtx = canvas.getContext('2d');
          initialCtx.drawImage(img, 0, 0);
          let width = img.width;
          let height = img.height;

          if (width > height) {
            if (width > MAX_WIDTH) {
              height *= MAX_WIDTH / width;
              width = MAX_WIDTH;
            }
          } else if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height;
            height = MAX_HEIGHT;
          }
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, width, height);

          return canvas.toBlob((imageBlob: any) => {
            imageBlob.name = `${width}x${height}${file.name}`;

            return resolveT(imageBlob);
          });
        });

      };

      return Promise.all(confs.map((a) => {
        return resize(a.maxWidth, a.maxHeight);
      })).then((result) => {
        return resolve(result);
      });

    };
    reader.onerror = (error) => {
      log.debug('Error is resizing image', error);

      return reject(error);
    };
  });

}
